<script>
import DataTable from '../UI/Table/DataTable.vue'
import { isTheme } from '../../Utils/isTheme'
import { globalVariablesMixin } from '../../Mixins/global'
import mixinComponent from '../../Mixins/mixinComponent'
import { isAdmin } from '../../Utils'

export default {
  components: { DataTable },
  mixins: [mixinComponent, globalVariablesMixin],
  emits: ['fetch'],
  computed: {
    contractColumns() {
      return [
        { name: 'id', displayable: false },
        { name: 'clientId', displayable: false },
        { name: 'supplierId', displayable: false },
        { name: 'platformId', displayable: false },
        { name: 'accountCodeSupplier', displayable: false },
        {
          name: 'createdAt',
          title: this.$t('contract.list.table.labelCreatedAt'),
          formatter: 'date',
        },
        {
          name: 'number',
          title: this.$t('contract.list.table.labelNumber'),
          formatter: 'context',
          options: { renderType: 'contracts', renderId: 'id' },
        },
        {
          name: 'agreementNumber',
          title: this.$t('contract.list.table.demandNumber'),
          style: { className: 'col-align-center' },
          displayable: isTheme('financia'),
        },
        {
          name: 'accountCodeClient',
          title: this.$t('contract.list.table.accountCodeClient'),
          displayable: isTheme('ciscar'),
        },
        {
          name: 'clientInfo.name',
          title: this.$t('main.client'),
        },
        {
          name: 'supplier.name',
          title: this.$t('main.supplier'),
          displayable: isAdmin(),
        },
        {
          name: 'platform.name',
          title: this.$t('contract.list.table.platformName'),
          displayable: !isTheme('financia'),
        },
        { name: 'companySalesman.fullname', title: this.$t('contract.list.table.companySalesmanName') },
        { name: 'platformSalesman.fullname', title: this.$t('contract.list.table.labelPlatformSalesman') },
        {
          name: 'rentInfo.rent',
          title: this.$t('contract.list.table.labelRentMonthly'),
          type: 'num-fmt',
          displayable: !isTheme('ciscar'),
          formatter: 'currency',
          style: { width: '60px;' },
        },
        {
          name: 'status',
          title: this.$t('contract.list.table.labelStatus'),
          formatter: 'status',
          options: { renderType: 'contract' },
          style: { width: '120px;', className: 'text-center' },
        },
        {
          name: 'startAt',
          title: this.$t('contract.list.table.startAt'),
          formatter: 'date',
          displayable: isTheme('financia'),
        },
        {
          name: 'endAt',
          title: this.$t('contract.list.table.endAt'),
          formatter: 'date',
          displayable: isTheme('financia'),
        },
        {
          name: 'refinancer.name',
          title: this.$t('contract.list.table.refinancerName'),
          displayable: isTheme('ciscar', 'olinn', 'financia'),
          style: { width: '120px;' },
        },
      ]
    },
    contractOrder() {
      return [[5, 'desc']]
    },
  },
  methods: {
    triggerFetch(callback) {
      this.$emit('fetch', callback)
    },
    reload() {
      this.$refs.restructuringContractList.renderDataTable()
    },
  },
}
</script>
<template>
  <DataTable
    id="restructuringContractList"
    ref="restructuringContractList"
    :columns="contractColumns"
    :order="contractOrder"
    :page-length="10"
    :fetch="triggerFetch"
  />
</template>
